import * as React from "react";
import { toast } from 'react-toastify';
import useTrans from "components/hooks/useTrans";

export default function useToast() {
    const { t } = useTrans();

    const successToast = (message: string = t("success")) => {
        return toast.success(message);
    };

    const buildErrors = (errors: string[]) => {
        const messages = errors.map((message: string) => {
            return <li key={message}>{message}</li>;
        });

        return <ul>{messages}</ul>;
    };

    const errorToast = (error: any = t("somethingWentWrong")) => {
        let errorString = t("somethingWentWrong");

        if (error.message && error.errors && error.errors.length > 0) {
            const content = <div><p>{error.message}</p>{buildErrors(error.errors)}</div>;
            return toast.error(content);
        }

        if (error.errors && error.errors.length > 0) {
            return toast.error(buildErrors(error.errors));
        }

        if (error !== "" && typeof error === "string") {
            errorString = error;
        }

        return toast.error(error.message ? error.message : errorString);
    };

    return { successToast, errorToast };
}
